import Page from '@/components/pages/static/StaticPageController';
import getStaticPaths from '@/components/pages/static/StaticPageStaticPaths';
import getStaticProps from '@/components/pages/static/StaticPageStaticProps';

export default Page;
export { getStaticProps, getStaticPaths };
